var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.901 11.707-7.62-8.93s3.377-1.165 4.92-1.748c1.64-.583 7.815 7.668 7.815 7.668l-5.114 3.01zm7.045-7.766c-.58 2.72-1.737 4.758-1.737 4.758l5.306 3.397c2.22-5.824-3.57-8.154-3.57-8.154zm3.57 8.155.482 6.116 2.218-.29s.58-.195.483-1.262c-.097-1.165-.29-3.592-.29-3.592s.097-.582-1.254-.776c-1.64-.292-1.64-.195-1.64-.195zm-10.131 6.99 6.078 2.717s-4.535 7.378-5.692 8.445c-1.048 1.055-2.964.758-4.32.548-.143-.022-.28-.044-.408-.062-1.35-.097-.965-.874-.965-.874l5.307-10.775zm0-.098-.579-7.183-13.121.874s-.772.097-.676 1.553c.097 1.942.29 4.078.29 4.078s-.097.873 1.64.97c1.736.098 12.253.098 12.446-.29zm6.175 2.816 4.437-3.592c.965.68 1.254 3.204 1.35 4.272.073.798-.232 1.162-.955 2.024-.244.292-.536.64-.877 1.082-1.448 1.747-1.93.195-1.93.195l-2.026-3.98z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQnt);
export default __webpack_public_path__ + "static/media/QNT.9986d79cd337b80d9238017cbc2037ba.svg";
export { ForwardRef as ReactComponent };